import * as XGSRegularIcons from "@fortawesome/free-regular-svg-icons";

export default XGSRegularIcons;
